import React from 'react';


function decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}




const ReadArticlePreviewCardRight = ({ text, authorName, date }) => {

    const textWithDecodedEntities = decodeHtml(text);

    const displayName = authorName ? (authorName === 'wesley@hydra' ? 'Sleep Geek' : authorName) : 'Sleep Geek';


    return (
        <div className="readArticlePreviewCard-right w-2/12 sm:w-1/2 flex flex-row justify-between">
            <div className="readArticlePreviewCard-right-content flex-col p-1">
                {/*<div className="readArticlePreviewCard-right-content-excerpt hidden 3xl:flex text-sm">{text.substring(0, 40).replace(/(<([^>]+)>)/gi, "")}...</div>*/}
                <div className="readArticlePreviewCard-right-content-excerpt hidden 3xl:flex text-sm">
                    {textWithDecodedEntities.substring(0, 40).replace(/(<([^>]+)>)/gi, "")}...
                </div>
                <div className="readArticlePreviewCard-right-content-author hidden 3xl:flex font-bold text-xxs">By {displayName}</div>
                <div className="readArticlePreviewCard-right-content-time hidden 3xl:flex text-xxs">{date.substring(0, 10)}</div>
            </div>
            <button className="readArticlePreviewCard-right-button flex flex-row gap-2 items-center">
                <div className=" text-sm sm:block hidden font-semibold">Read</div>
                <i className="ri-arrow-right-line text-xl text-gold-accent"></i>
            </button>
        </div>
    );
};

export default ReadArticlePreviewCardRight;